export default {
    functional: true,
    render(createElement, context) {
        if (context.data.tag || context.props.tag) {
            return createElement(context.data.tag, context.data, context.children);
        }

        return context.children;
    },
};
